import React, { useEffect, useState } from 'react';
import StripesBackground from '../components/StripesBackground';
import { contentAPI } from '../utils/api';

const CV = () => {
  const [content, setContent] = useState(null);
  const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

  // Helper function to get the correct URL (for Cloudinary or local files)
  const getMediaUrl = (url) => {
    if (!url) return null;
    // If URL starts with http:// or https://, it's already a complete URL
    if (url.startsWith('http://') || url.startsWith('https://')) {
      return url;
    }
    // Otherwise, it's a relative path, prepend BACKEND_URL
    return `${BACKEND_URL}${url}`;
  };

  useEffect(() => {
    loadContent();
  }, []);

  const loadContent = async () => {
    try {
      const response = await contentAPI.getPageContent('cv');
      setContent(response.data);
    } catch (error) {
      console.error('Failed to load CV content:', error);
    }
  };

  const defaultContent = `EXPERIENCE

VFX Supervisor | Various Studios | 2011 - Present
• Leading visual effects teams on major film and TV productions
• Overseeing the entire VFX pipeline from pre-production to final delivery
• Collaborating with directors and cinematographers to achieve creative vision

VFX Compositor | Double Negative | 2007 - 2011
• Worked on high-profile projects including Harry Potter series
• Specialized in complex compositing and digital effects
• Contributed to Academy Award-winning visual effects

VFX Compositor | Various Productions | 2002 - 2007
• Created visual effects for films and live spectaculars
• Worked on projects for artists including Celine Dion
• Developed expertise in compositing and digital imagery

EDUCATION

I.A.D. Cinema School | Belgium | 2002
• Graduated with specialization in Visual Effects
• Comprehensive training in film production and post-production

SKILLS

• VFX Supervision & Team Leadership
• Compositing (Nuke, After Effects)
• 3D Software (Maya, Houdini)
• Color Grading
• On-set VFX Supervision
• Pipeline Management
• Photography
• Graphic Design
• Music Production`;

  return (
    <div className="min-h-screen bg-black pt-20 pb-24" data-testid="cv-page">
      <div className="relative py-16">
        <div 
          className="absolute inset-0"
          style={{
            backgroundImage: 'repeating-linear-gradient(90deg, transparent, transparent 2px, rgba(255,255,255,0.1) 2px, rgba(255,255,255,0.1) 4px)',
          }}
        />
        
        <div className="container mx-auto px-6 relative z-10 max-w-4xl">
          {/* Header */}
          <div className="text-center mb-12">
            <h1 className="text-4xl font-bold text-white mb-4" data-testid="cv-title">Curriculum Vitae</h1>
            <div className="w-32 h-0.5 bg-white mx-auto"></div>
          </div>

          {/* CV Content */}
          <div className="bg-white p-8 md:p-12 rounded-lg shadow-lg">
            {/* CV Images */}
            {content?.cv_images && content.cv_images.length > 0 && (
              <div className="grid grid-cols-2 md:grid-cols-3 gap-4 mb-8">
                {content.cv_images.map((img, index) => (
                  <img
                    key={index}
                    src={getMediaUrl(img)}
                    alt={`CV Image ${index + 1}`}
                    className="w-full rounded-lg shadow-md"
                    data-testid={`cv-image-${index}`}
                  />
                ))}
              </div>
            )}

            {/* CV Text */}
            <div 
              className="prose prose-lg max-w-none text-gray-800" 
              data-testid="cv-content"
              dangerouslySetInnerHTML={{ __html: content?.content || defaultContent }}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default CV;
